import http from '../libs/http'

export const login = (phone, password) => {
  return http.post({
    url: '/api/user/session',
    data: {
      phone,
      password
    }
  }).then((res) => {
    return res;
  })
};

export const logout = () => {
  return http.delete({
    url: '/api/user/session',
  }).then((res) => {
    return res;
  })
};

export const register = (nickname, phone, password, vcode, inviteCode) => {
  return http.post({
    url: '/api/user',
    data: {
      nickname,
      phone,
      password,
      code: vcode,
      inviteCode,
    }
  }).then((res) => {
    return res;
  })
};

export const forget_password = (phone, password, vcode) => {
  return http.post({
    url: '/api/user/forget_password',
    data: {
      phone,
      password,
      code: vcode,
    }
  }).then((res) => {
    return res;
  })
};

//获取验证码 1.表示注册 2.表示忘记密码 3.表示验证
export const get_vcode = (phone, type, user_id, settingType) => {
  return http.post({
    url: '/api/user/get_vcode',
    data: {
      phone,
      type,
      user_id,
      settingType
    }
  }).then((res) => {
    // // console.log('get code result', res);
    return res;
  })
};

// 获取用户 session 信息
export const get_session = () => {
  return http.get({
    url: '/api/user/session'
  }).then(res => {
    window.localStorage.setItem('editorLogInfo',JSON.stringify(res.data.data))
    return res
  })
};

// 获取用户信息
export const getUserInfo = (user_id) => {
  return http.get({
    url: '/api/user',
    data: {
      params: {
        user_id,
      }
    }

  }).then(res => {
    return res
  })
};

export const get_captcha = (code, user_id, settingType) => {
  return http.get({
    url: '/api/user/get_captcha',
    data: {
      params: {
        code,
        user_id,
        settingType
      }

    }
  }).then(res => {
    return res
  })
};

// 获取用户信息
export const getUsers = (app_id) => {

  console.log(app_id, '---app_id---');

  return http.get({
    url: '/api/users',
    data: {
      params: {
        app_id,
      }
    }

  }).then(res => {
    return res;
  })
};



// WEBPACK FOOTER //
// ./src/apis/user_api.js